import { FC, useState } from "react"
import {
  Box,
  Button,
  Collapse,
  Container,
  Stack,
  Typography,
} from "@mui/material"
import AddIcon from "@mui/icons-material/Add"
import { useTitle } from "@/core/hooks"
import { SherlokQueryForm } from "../components/forms/sherlokQueryForm"
import { SherlokQueriesTable } from "../components/tables/sherlokQueriesTable"
import { QueriesToolbar } from "../components/tables/queriesToolbar"

export const SherlokPage: FC = () => {
  useTitle("Sherlok — поиск")

  return (
    <Container maxWidth={false} sx={{ py: 2 }}>
      <Stack spacing={2}>
        <Box sx={{ p: 2, border: 1, borderColor: "divider", borderRadius: 1 }}>
          <SherlokQueryForm
            onSuccess={() => {
              /* keep form open */
            }}
          />
        </Box>

        <QueriesToolbar />
        <SherlokQueriesTable />
      </Stack>
    </Container>
  )
}
